<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>系统管理</el-breadcrumb-item>
			<el-breadcrumb-item>系统日志</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="form-bar">
			<el-form :inline="true">
				<el-form-item label="时间范围">
					<DateRange v-model="dateRange" />
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSubmit">日志查询</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="tableList">
			<SystemList v-show="action == 'search'" :action="action" :params="queryData" />
		</div>
	</div>
</template>

<script>
	import DateRange from '@/components/DateRangePicker'
	import SystemList from './SystemList'
	export default {
		components: {
			DateRange,
			SystemList,
		},
		data() {
			return {
				dateRange: [],
				action: '',
			}
		},
		computed: {
			queryData() {
				var data = {
					dateStart: this.dateRange[0],
					dateEnd: this.dateRange[1],
				}
				return data
			},
		},
		watch: {
			dateRange(value) {
				console.log('dateRange', value)
			},
		},
		methods: {
			onSubmit() {
				this.action = 'search'
				console.log('submit!')
			},
		},
	}
</script>

<style></style>
